export interface PopinConfirmationState {
	open: boolean,
	date: string
}

export const INITIAL_POPIN_CONFIRMATION: PopinConfirmationState = {
	open: false,
	date: ''
}